import React from 'react';
import { Text, Group, maestro, HeadphonesAddOutlined } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import { Trans } from '@lingui/macro';
import { RouterLink } from 'components/CommonUi/RouterLink';
import { useCreatorFooter } from './CreatorFooter.helpers';

const footer = css({
    width: 'calc(100% - 16px)',
    textAlign: 'center',
    padding: 'md',
    margin: 'xs',
    borderRadius: 'lg',
    backgroundColor: 'surface.low',
    _hover: {
        backgroundColor: 'surface.neutral.low.hover',
    },
});

const CreatorFooter: React.FC = () => {
    const { showCreatorFooter, addSampleLink, handleAddSampleClick } =
        useCreatorFooter();

    if (!showCreatorFooter) {
        return null;
    }

    return (
        <RouterLink to={addSampleLink} onClick={handleAddSampleClick}>
            <maestro.section className={footer}>
                <Group justifyContent="center" gap="sm">
                    <Group.Item alignSelf="center">
                        <HeadphonesAddOutlined />
                    </Group.Item>
                    <Group.Item alignSelf="center">
                        <Text fontWeight="bold">
                            <Trans>Add a loop</Trans>
                        </Text>
                    </Group.Item>
                </Group>
            </maestro.section>
        </RouterLink>
    );
};

export default CreatorFooter;
